import React from 'react';
import { BsFonts } from '@react-icons/all-files/bs/BsFonts';
import { LIGHT_THEME } from '@bucketplace/design-system';

import { decorateComponent } from '../../documentComponents';
import { Text } from './Text';
import { TextInspector } from './Text.Inspector';

export default decorateComponent(Text, 'block', {
  id: 'text',
  label: '텍스트',
  defaultProps: {
    size: 13,
    color: LIGHT_THEME.content.base1,
    weight: 'lighter',
    align: 'left',
    background: 'none',
  },
  allowedChildren: [],
  disallowedAncestors: ['carousel'],
  renderIcon: () => <BsFonts />,
  renderTitle: ({ value }) => `${value || '내용없는 텍스트'}`,
  renderInspector: TextInspector,
});
